import {
  Input,
  type InputHandle,
  type InputProps,
} from '@progress/kendo-react-inputs'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledInput.css'

export type StyledInputProps = InputProps & {
  'data-testid'?: string
  width?: '100%' | 'default'
  onValueChange?: (value: string) => void
}

export type StyledInputRef = InputHandle

export const StyledInput = React.forwardRef<StyledInputRef, StyledInputProps>(
  (
    {
      className,
      'data-testid': dataTestId = 'components-elements-styled-input',
      onChange,
      onValueChange,
      width = 'default',
      ...rest
    },
    ref,
  ) => {
    const handleChange = React.useCallback<EH<InputProps, 'onChange'>>(
      (event) => {
        onChange?.(event)
        onValueChange?.(event.value)
      },
      [onChange, onValueChange],
    )

    return (
      <Input
        ref={ref}
        autoComplete="off"
        className={classNames(styles.root, styles[`width-${width}`], className)}
        data-testid={dataTestId}
        onChange={handleChange}
        {...rest}
      />
    )
  },
)
